import { useTranslation } from "react-i18next";
import squares from "../../shared/assets/img/squares.png";
import styles from "./styles.module.css";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["page-layout"]}>
      <div className={styles.title}>{t("404.message")}</div>
      <img className={styles["background-squares"]} src={squares} alt="" />
    </div>
  );
};
